import variables from '../../variables.module.scss';

const MuiMenuItem = {
  styleOverrides: {
    root: {
      fontFamily: variables.fontRegular,
      color: variables.headerLinksFontColor,
    },
  },
};

export default MuiMenuItem;
